// extracted by mini-css-extract-plugin
export default {"container":"AnnotationList__container--jSg1xprtfb","empty-message-box":"AnnotationList__empty-message-box--llwGGwBHCj","empty-message":"AnnotationList__empty-message--4e9YdWBt4S"};